import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { PageToolbarComponent } from '../../shared/components/page-toolbar/page-toolbar.component';

@Component({
  standalone: true,
  selector: 'mon-not-found',
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, PageToolbarComponent],
})
export class NotFoundComponent {}
